export const INITIAL_SET_DATA = 'INITIAL_SET_DATA';
export const SET_DATA = 'SET_DATA';
export const SET_MODE = 'SET_MODE';
export const UPDATE_QUIZ_DATA = 'UPDATE_QUIZ_DATA';
export const UPDATE_ANSWER_DATA = 'UPDATE_ANSWER_DATA';
export const UPDATE_ANSWER_SINGLE_DATA = 'UPDATE_ANSWER_SINGLE_DATA';
export const CLEAR_ANSWER_DATA = 'CLEAR_ANSWER_DATA';
export const CLEAR_ANSWER_DATA_BY_INDEX = 'CLEAR_ANSWER_DATA_BY_INDEX';
export const RELOAD_ENTRY = 'RELOAD_ENTRY';

export function updateCommonData(type, data) {
    return { type, data };
}

export function updateQuizData(type, data) {
    return { type, data };
}



// WEBPACK FOOTER //
// ./actions/index.js